import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Toaster } from '../../classes/toaster.class';
import { ENucToastType, NucToastDataModel } from '@relayter/rubber-duck';
import { ConnectivityService } from '../../services/connectivity.service';

@Component({
    selector: 'rl-app',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
    private readonly connectivityService = inject(ConnectivityService);
    private readonly destroyRef = inject(DestroyRef);
    private toastData: NucToastDataModel;

    public ngOnInit(): void {
        this.connectivityService.offline$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(this.showOfflineToaster.bind(this));

        this.connectivityService.online$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(this.removeOfflineToaster.bind(this));
    }

    private showOfflineToaster() {
        this.toastData = new NucToastDataModel(
            ENucToastType.WARNING,
            'Internet connectivity issues',
            'We’re unable to load data at the moment. Check your' + ' internet connection or try again in a few seconds.',
            true
        );
        Toaster.openToast(this.toastData);
    }

    private removeOfflineToaster() {
        if (this.toastData) {
            this.toastData.loading = false;
            this.toastData = undefined;
        }
    }
}
